import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RoleItemProps } from "apis/role";
import { PaginationProps } from "utils/types/API";

export interface RoleState {
    loading: boolean;
    list: {
        data: RoleItemProps[];
        options: RoleItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: RoleItemProps;
    };
}

const initialState: RoleState = {
    loading: false,
    list: {
        data: [],
        options: []
    },
    item: {
    }
};

interface IndexProps {
    data: RoleItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: RoleItemProps;
}
export const roleSlice = createSlice({
    name: "role",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, find, create, update } = roleSlice.actions;
export default roleSlice.reducer;
